import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=718d7005&scoped=true&"
import script from "./Instagram.vue?vue&type=script&lang=js&"
export * from "./Instagram.vue?vue&type=script&lang=js&"
import style1 from "./Instagram.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Instagram.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718d7005",
  null
  
)

export default component.exports